import styled from 'styled-components';

const Wrapper = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  background: transparent;
  
  .block-input-element {
  	width: 100%;
  }
  
  @media(max-width: 670px) {
		margin-left: .4em;
    margin-right: .4em;
  }
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./src/html/components/Calculator/Wrapper.js